import { render, staticRenderFns } from "./RightTabConsult.vue?vue&type=template&id=cffc91f6&"
import script from "./RightTabConsult.vue?vue&type=script&lang=js&"
export * from "./RightTabConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports